module.exports = __webpack_public_path__ + "img/mcdonalds.c690ee99.png";